/// <reference path="../types.d.ts" />

import { cmxLocation, appServiceLines } from '@codametrix/ui-common';
import { patchSessionAttributes } from '@codametrix/client-session';
import history from '../history';
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { ServiceLine } from './action-types';
import { applyDefaultFilters, clearAllFilters } from './cases.action';
import { getEula, saveEula } from './eula-shared.actions';
import { navigateContext } from './navigation.actions';

import { fetchTableauToken } from './analytics';

const saveServiceLine = createAction<CMx.ServiceLine>(
  ServiceLine.SAVE_SERVICE_LINE
);

const chooseServiceLine = createAsyncThunk(ServiceLine.CHOOSE_SERVICE_LINE, async (
  payload: CMx.chooseServiceLinePayload,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  const { serviceLine, context, homepagePreference } = payload;
  dispatch(saveServiceLine(serviceLine));

  try {
    await patchSessionAttributes({ serviceLineId: serviceLine.id });
  } catch {
    // Non-blocking: the org/service-line switch must not fail over this.
  }

    const location = cmxLocation.getLocation();
    if (location === '/eula/') {
      const eulaUpToDate = await getEula(
        context.user.id || -1,
        context.activeContext?.organizationId || -1
      );
      dispatch(saveEula(eulaUpToDate));
      history.push(location);

    return;
  }

  dispatch(navigateContext({ context, homepagePreference }));
});

const navigateServiceLine = createAsyncThunk(ServiceLine.NAVIGATE_SERVICE_LINE, async (
  payload: CMx.navigateServiceLinePayload,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  const { choice, context, actionGroups } = payload;
  dispatch(saveServiceLine(choice));

  dispatch(clearAllFilters());
  dispatch(applyDefaultFilters(context));

  if (
    actionGroups.find((ag: any) => ag.options[0].active === true)?.key === 'cases'
  ) {
    history.replace(`/cmx/cases/${appServiceLines.toServiceLineSlug(choice.name)}/`);
  } else if (
    actionGroups.find((ag: any) => ag.options[0].active === true)?.key ===
    'tableau-dashboard'
  ) {
    dispatch(fetchTableauToken(choice));
    history.push('/cmx/tableau/');
  }
});

export { chooseServiceLine, saveServiceLine, navigateServiceLine };
